import { Minus, Plus } from "lucide-react";
import { fmt } from "@/lib/booking";
import { t } from "@/lib/i18n";

export default function Counter({ id, label, sub, value, onChange, min = 0, canInc, dark = false }) {
  const btn = `inline-flex items-center justify-center h-12 w-12 rounded-full border text-lg transition-colors disabled:opacity-35 ${
    dark ? "border-cream/40 hover:bg-white/10" : "border-forest/30 text-forest hover:bg-forest/[0.06]"
  }`;
  return (
    <div className="flex items-center justify-between gap-4 py-4" data-testid={`counter-${id}`}>
      <div className="min-w-0">
        <p className="font-semibold" id={`${id}-label`}>{label}</p>
        {sub && <p className={`text-sm ${dark ? "text-cream/75" : "text-ink-muted"}`}>{sub}</p>}
      </div>
      <div className="flex items-center gap-3" role="group" aria-labelledby={`${id}-label`}>
        <button type="button" className={btn} onClick={() => onChange(value - 1)} disabled={value <= min} aria-label={fmt(t("bilet.counts.dec"), { label })} data-testid={`counter-${id}-dec`}>
          <Minus className="h-5 w-5" aria-hidden="true" />
        </button>
        <output className="w-8 text-center text-2xl font-semibold tabular-nums" aria-live="polite" data-testid={`counter-${id}-value`}>{value}</output>
        <button type="button" className={btn} onClick={() => onChange(value + 1)} disabled={!canInc} aria-label={fmt(t("bilet.counts.inc"), { label })} data-testid={`counter-${id}-inc`}>
          <Plus className="h-5 w-5" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
